module.exports = __webpack_public_path__ + "static/img/person.84cbafd4.svg";